<template>
    <div>
        <b-button v-if="item.actions.isSugerivel" size="sm" @click="carregarRelatorioSugerido(item)"
            :disabled="item.actions.currentProgress > 0" style="width: 9rem;">
            <b-spinner small v-if="item.actions.currentProgress > 0" class="mr-2"></b-spinner>
            <span>{{ buttonName }}</span>
        </b-button>
        <span v-else>Não</span>
    </div>
</template>

<script>
import pcaService from "@/services/entregas/pcaService";

export default {
    props: {
        item: {
            type: Object
        },
        newIdPrestacaoConta: {
            type: Number
        }
    },
    data() {
        return {
        }
    },
    computed: {
        buttonName() {
            if (this.item.actions.currentProgress > 0) {
                return 'Carregando'
            } else if (this.item.actions.isSaved) {
                return 'Recarregar'
            } else {
                return 'Sim, carregar'
            }
        }
    },
    methods: {
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        /** Busca um relatório sugerido na api de relatórios, guarda na entrega do usuário, permite download */
        async carregarRelatorioSugerido(item) {
            if (this.item.actions.isSaved) {
                this.$bvModal.msgBoxConfirm('Ao recarregar, o arquivo retificado será removido (se houver). Tem certeza?', {
                    buttonSize: 'sm',
                    cancelTitle: 'Não',
                    cancelVariant: 'outline-secondary',
                    centered: true,
                    headerBgVariant: 'secondary',
                    headerTextVariant: 'light',
                    okTitle: 'Sim, apague o arquivo de retificação',
                    title: 'Confirmar',
                }).then(value => {
                    if (value) {
                        this.carregarRealmente(item)
                    }
                }).catch(err => {
                    console.error('Erro ao validar recarga de relatório sugerido', err)
                })
            } else {
                this.carregarRealmente(item)
            }
        },
        async carregarRealmente(item) {
            try {
                item.actions.currentProgress = 10
                //await this.sleep(10000);
                const response = await pcaService.carregarRelatorioSugerido(this.newIdPrestacaoConta, item.Id)
                if (response && response.status === 200) {
                    //console.log('carregarRelatorioSugerido deu 200', response)
                    item.actions.currentProgress = 70
                    this.$emit("updateAll", response.data);
                    this.$toast.success('Relatório carregado com sucesso')
                } else {
                    if (response && response.data && response.data.msg)
                        this.$toast.error(response.data.msg);
                    else this.$toast.error("Erro ao obter o arquivo");
                }
                //console.log(response)
            } catch (e) {
                console.error('erro ao carregarRelatorioSugerido', item, e)
                this.$toast.error("Erro ao obter o arquivo");
            } finally {
                item.actions.currentProgress = 0
            }
        }
    },
}
</script>

<style scoped></style>